import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PatientSummary } from '../models/patient.model';
import { PatientsService } from '../services/patients.service';

@Injectable({
  providedIn: 'root'
})
export class PatientSummariesResolver implements Resolve<PatientSummary[]> {
  
  constructor(private patientsService: PatientsService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<PatientSummary[]> {
    return this.patientsService.getPatientSummaries().pipe(
      catchError(error => {
        return of([]); // Return empty array on error
      })
    );
  }
}
